import React, { useMemo } from 'react';
import dynamic from 'next/dynamic';
import { modules } from './contants';
import 'react-quill/dist/quill.snow.css';

const RichTextField = ({
  name,
  placeholder = 'Empty',
  disabled = false,
  onChange,
  value,
  error,
  readonly,
  ...rest
}) => {
  const ReactQuill = useMemo(
    () => dynamic(() => import('react-quill'), { ssr: false }),
    []
  );

  const _handleChange = (val) => {
    const newValue = val === '<p><br></p>' ? '' : val;

    onChange(newValue);
  };

  return (
    <ReactQuill
      placeholder={placeholder}
      value={value}
      modules={modules}
      onChange={_handleChange}
      readOnly={readonly || disabled}
      {...rest}
    />
  );
};

export default RichTextField;
